import { apiFetch } from '../http';
export function getUserMapPointDetail(params) {
    return apiFetch(`/travel/api/map_point_detail/${encodeURIComponent(params.source)}/${encodeURIComponent(String(params.pointId))}/`, { baseUrl: params.baseUrl, token: params.token, method: 'GET', cache: 'no-store' });
}
export function getTravelMapPointDetail(params) {
    return apiFetch(`/travel/api/travel_map_point_detail/${encodeURIComponent(String(params.travelPlanId))}/${encodeURIComponent(String(params.pointId))}/`, { baseUrl: params.baseUrl, token: params.token, method: 'GET', cache: 'no-store' });
}
// Each mounted map owns its cache. Refreshing the map or changing accounts/plans
// clears it. Failed requests are never cached, concurrent clicks share one load.
export function createMapPointDetailsCache(ttlMs = 300000, maxEntries = 200) {
    const entries = new Map();
    return {
        clear: () => entries.clear(),
        invalidate: (key) => entries.delete(key),
        get(key, load) {
            const cached = entries.get(key);
            if (cached && Date.now() - cached.at < ttlMs)
                return cached.promise;
            const entry = { at: Date.now(), promise: Promise.resolve().then(load) };
            entries.delete(key);
            entries.set(key, entry);
            if (entries.size > maxEntries)
                entries.delete(entries.keys().next().value);
            entry.promise.catch(() => { if (entries.get(key) === entry)
                entries.delete(key); });
            return entry.promise;
        },
    };
}
